import { CSSProperties } from 'react';
import styled from 'styled-components';
import MarkdownBase, { Options } from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface ChatMarkdownProps extends Options {
  dir?: 'auto' | 'ltr' | 'rtl';
  style?: CSSProperties;
}

const ChatMarkdownStyled = styled(MarkdownBase)`
  font-size: 14px;
  line-height: 1.6;
  color: ${({ theme }) => theme.palette.common.black};

  > *:first-child {
    margin-top: 0;
  }

  > *:last-child {
    margin-bottom: 0;
  }

  p {
    margin: 0;
    line-height: 1.6;
  }

  p + p {
    margin-top: 12px;
  }

  a {
    color: ${({ theme }) => theme.palette.common.blue};
  }

  ul,
  ol {
    margin: 12px 0;
    padding-left: 22px;
    line-height: 1.6;
  }

  li + li {
    margin-top: 4px;
  }

  li > ul,
  li > ol {
    margin: 4px 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 20px 0 8px;
    font-weight: ${({ theme }) => theme.typography.fontWeightBold};
    line-height: 1.3;
  }

  h1 {
    font-size: 18px;
  }

  h2 {
    font-size: 16px;
  }

  h3 {
    font-size: 15px;
  }

  h4,
  h5,
  h6 {
    font-size: 14px;
  }

  blockquote {
    margin: 12px 0;
    padding-left: 12px;
    border-left: 2px solid ${({ theme }) => theme.palette.common.gray5};
    color: ${({ theme }) => theme.palette.common.gray2};
  }

  code {
    font-family: 'Geist Mono', monospace;
    font-weight: 500;
    background: ${({ theme }) => theme.palette.common.gray5};
    color: ${({ theme }) => theme.palette.common.black};
    padding: 0 4px 1px;
    border-radius: 2px;
    white-space: pre-wrap;
  }
`;

const ChatMarkdown = (props: ChatMarkdownProps) => (
  <ChatMarkdownStyled {...props} remarkPlugins={[remarkGfm]} />
);

export default ChatMarkdown;
